import React from "react";

const RoleEditorPage = () => {return (<div></div>)}

export default RoleEditorPage